class CalendarDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener(
      "dispatch:calendar-drawer:open",
      this.openDrawerViaEventHandler,
    );
    document.addEventListener(
      "dispatch:calendar-drawer:close",
      this.closeDrawerViaEventHandler,
    );
    this.addEventListener("on:calendar-drawer:before-open", async () => {
      let data = {
        customerId: window.customerId,
        shop: window.shopUrl,
      };
      
      console.log("Calendar loading with data:", data);

      // Fetch customer data
      document.querySelector(".calendar-loader-container").style.display =
        "flex";
      
      let customerData;
      try {
        customerData = await fetchAppProxyData("get_customer_data", data);
        console.log("Calendar API response:", customerData);
      } catch (error) {
        console.error("Calendar loading error:", error);
        document.querySelector(".calendar-loader-container").style.display = "none";
        return; // Exit early if data fetch fails
      }
      
      document.querySelector(".calendar-loader-container").style.display =
        "none";

      // Clear the contents of elements with class 'calendar-drawer__content-item'
      const contentItems = this.querySelectorAll(
        ".calendar-drawer__content-items",
      );
      contentItems.forEach((item) => (item.innerHTML = ""));

      // Add new calendar items based on fetched data
      let first = true;
      if (contentItems.length > 0 && customerData.event_details) {
        const firstContentItem = contentItems[0];
        if (customerData.event_details.length > 0) {
          customerData.event_details.forEach((itemData) => {
            const newItem = this.createCalendarItem(itemData);

            const date = new Date(itemData.date);
            const month = date.toLocaleString("default", { month: "long" });
            const existingElement = document.querySelector(
              `.calendar-${month}`,
            );

            if (!existingElement && !first && window.deets.case_each_month) {
              const caseItem = document.createElement("div");

              caseItem.style.setProperty("height", "40px", "important");
              caseItem.innerHTML += `
              <div class="calendar-product-details" style="height:40px !important; cursor: none; !important;">
                <div class="calendar-product-image">
                  <img height="30" src="https://cdn.shopify.com/s/files/1/0831/2740/2829/files/Case-only-scaled.webp?v=1726588920" alt="Case">
                </div>
                <div class="calendar-product-title">
                  <h5 style="font-size:20px" >Case</h5>
                </div>
              </div>
            `;
              firstContentItem.appendChild(caseItem);
            }
            firstContentItem.appendChild(newItem);
            first = false;
          });

          // Bind remove and drag events after items are added
          this.bindRemoveEvents();
          this.bindDragEvents();

          if (window.deets.case_each_month) {
            const caseItem = document.createElement("div");

            caseItem.style.setProperty("height", "40px", "important");
            caseItem.innerHTML += `
            <div class="calendar-product-details" style="height:40px !important; cursor: none; !important;">
              <div class="calendar-product-image">
                <img height="30" src="https://cdn.shopify.com/s/files/1/0831/2740/2829/files/Case-only-scaled.webp?v=1726588920" alt="Case">
              </div>
              <div class="calendar-product-title">
                <h5 style="font-size:20px" >Case</h5>
              </div>
            </div>
          `;
            firstContentItem.appendChild(caseItem);
          }
        } else {
          const newItem = this.createCalendarEmptyItem();
          firstContentItem.appendChild(newItem);
        }
      }

      // Update the calendar footer content
      const calendarFooterContent = this.querySelector(
        ".calendar-footer-content",
      );
      if (calendarFooterContent) {
        var deets = getJsonCookie("deets");

        // Use next delivery date from Seal subscription if available
        let nextDeliveryDate;
        if (deets.nextDeliveryDate) {
          nextDeliveryDate = new Date(deets.nextDeliveryDate);
        } else {
          // Fallback to calculating from last ordered date
          const date = new Date(deets.lastOrdered);
          let month_date = date.getMonth();
          let year = date.getFullYear();
          nextDeliveryDate = new Date(year, month_date, 10);
        }

        const month = nextDeliveryDate.toLocaleString("default", { month: "long" });

        const days = Math.floor(
          Math.abs(nextDeliveryDate - new Date()) / (1000 * 60 * 60 * 24),
        );

        calendarFooterContent.textContent = `You have ${days} days left to pick your ${month} scents`;
      }

      theme.manuallyLoadImages(this);
    });

    const calendarButton = document.querySelector(".header-calendar-link");
    if (calendarButton) {
      calendarButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.open();
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener(
      "dispatch:calendar-drawer:open",
      this.openDrawerViaEventHandler,
    );
    document.removeEventListener(
      "dispatch:calendar-drawer:close",
      this.closeDrawerViaEventHandler,
    );
  }

  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  async close(opener) {
    // Call the original close method from SideDrawer (parent class)
    super.close(opener);
    console.log("Calendar drawer has been closed");
    const calendarItems = document.querySelectorAll(".calendar-item");

    calendarItems.forEach((element) => {
      element.setAttribute("draggable", "false");
      var date = element.dataset.date;
    });

    console.log("fetch");
    let data = {
      customerId: window.customerId,
    };
    const customerData = await fetchAppProxyData(
      "sync_seal_with_calendar",
      data,
    );
  }

  createCalendarItem(itemData) {
    const date = new Date(itemData.date);
    const month = date.toLocaleString("default", { month: "long" });

    const existingElement = document.querySelector(`.calendar-${month}`);

    const newItem = document.createElement("div");
    newItem.classList.add("calendar-item");
    newItem.setAttribute("draggable", "true");
    newItem.dataset.date = itemData.date;
    newItem.dataset.productId = itemData.product_id;

    if (!existingElement) {
      newItem.innerHTML += `<h4 class="calendar-${month}">${month}</h4>`;
    }

    let itemName = itemData.name.replace(/- subscription/i, "");
    itemName = itemData.name.replace("-", " ");

    if (itemData.type != "fragrance") {
      newItem.style.setProperty("height", "90px", "important");
      newItem.innerHTML += `
      <div class="calendar-product-details" style="height:90px !important;">
        <div class="calendar-product-image">
          <img class="product-image-calendar" src="${
            itemData.image_url
          }" alt="${itemData.image_alt || itemData.name}">
        </div>
        <div class="calendar-product-title">
          <h5 style="font-size:20px" >${itemName}</h5>
          ${
            itemData.premium_value && itemData.premium_value > 0
              ? `<p class="calendar-upcharge" style="font-size:20px">+ £${itemData.premium_value} UPCHARGE</p>`
              : ""
          }
        </div>
        <div class="calendar_remove" data-date="${
          itemData.date
        }" data-product-id="${itemData.product_id}">
          <img class="calendar_remove_icon" src="https://scentandco.com/wp-content/themes/hello-elementor/assets/img/snc_remove.png">
        </div>
      </div>
    `;
    } else {
      newItem.innerHTML += `
      <div class="calendar-product-details">
        <div class="calendar-product-image">
          <img class="product-image-calendar" src="${
            itemData.image_url
          }" alt="${itemData.image_alt || itemData.name}">
        </div>
        <div class="calendar-product-title">
          <h5>${itemName}</h5>
          ${
            itemData.premium_value && itemData.premium_value > 0
              ? `<p class="calendar-upcharge">+ £${itemData.premium_value} UPCHARGE</p>`
              : ""
          }
        </div>
        <div class="calendar_remove" data-date="${
          itemData.date
        }" data-product-id="${itemData.product_id}">
          <img class="calendar_remove_icon" src="https://cdn.shopify.com/s/files/1/0831/2740/2829/files/snc_remove.webp?v=1727788305">
        </div>
      </div>
    `;
    }

    return newItem;
  }

  createCalendarEmptyItem() {
    var emptyDeets = getJsonCookie("deets");
    const date = new Date(emptyDeets.lastOrdered);
    let month_date = date.getMonth();
    let year = date.getFullYear();

    var freq = 1;
    var skipped = 0;
    if (emptyDeets) {
      var skipped = emptyDeets.skippped_months
        ? window.deets.skippped_months
        : 0;
      var freq = emptyDeets.sub_frequency ? window.deets.sub_frequency : 1;

      console.log("emptyDeets: ", emptyDeets);
      var createdDate = new Date();

      // Get the month (zero-based, so January is 0 and December is 11)
      var monthIndex = createdDate.getMonth();
      var yearIndex = createdDate.getYear();

      if (emptyDeets.skipped_cancelled == "true") {
        skipped = 0;
      }
    } else {
      var monthIndex = month_date;
    }

    // if (date.getDate() >= 10) {
    //   month_date += 1;

    //   if (skipped > 0) {
    //     month_date += skipped;
    //   }

    //   if (freq > 1) {
    //     month_date += freq;
    //   }

    //   if (month_date === 12) {
    //     month_date = 0;
    //     year += 1;
    //   }
    // } else {
    //   if (month_date == monthIndex && yearIndex == year) {
    //     month_date += 1;
    //   }
    // }

    const calendarDate = new Date(year, month_date, 1);
    const month = calendarDate.toLocaleString("default", { month: "long" });

    const newItem = document.createElement("div");
    newItem.innerHTML = `
      <div class="calendar-item">
        <h4>${month}</h4>
        <div class="calendar-product-details">
            <div class="calendar-product-image">
              <img class="product-image-calendar" src="https://cdn.shopify.com/s/files/1/0831/2740/2829/files/snc_add_placeholder.webp?v=1727788160 " alt="Pick your Scent">
            </div>
            <div class="calendar-product-title">
              <h5>Pick your Scent</h5>
              <a href="/collections/all" style="color:#212121 !important">
                <p>Start by adding your first scent to your calendar</p>
              </a>
            </div>

        </div>
      </div>
    `;
    return newItem;
  }

  bindRemoveEvents() {
    const removeButtons = this.querySelectorAll(".calendar_remove");
    removeButtons.forEach((button) => {
      button.addEventListener("click", this.handleRemoveClick.bind(this));
    });
  }

  bindDragEvents() {
    const calendarItems = this.querySelectorAll(".calendar-item");
    calendarItems.forEach((item) => {
      item.addEventListener("dragstart", this.handleDragStart.bind(this));
      item.addEventListener("dragover", this.handleDragOver.bind(this));
      item.addEventListener("drop", this.handleDrop.bind(this));
    });
  }

  async handleRemoveClick(event) {
    const removeButton = event.currentTarget;
    const productId = removeButton.getAttribute("data-product-id");
    const date = removeButton.getAttribute("data-date");
    var removeDeets = getJsonCookie("deets");

    var skipped = removeDeets.skippped_months;
    if (removeDeets.skipped_cancelled == "true") {
      skipped = 0;
    }

    let data = {
      customerId: window.customerId,
      productId: productId,
      date: date,
      skipped: skipped,
      plan_freq: removeDeets.sub_frequency,
      products_per_month: removeDeets.products_per_month,
      last_ordered: removeDeets.lastOrdered,
    };
    const customerData = await fetchAppProxyData(
      "remove_customer_product_from_calendar",
      data,
    );
    console.log("Removed: ", JSON.stringify(customerData));
    const calendarDrawer = this.closest("calendar-drawer");
    if (calendarDrawer) {
      const event = new CustomEvent("on:calendar-drawer:before-open", {
        bubbles: true,
        cancelable: true,
      });
      calendarDrawer.dispatchEvent(event);
    }
  }

  handleDragStart(event) {
    event.dataTransfer.setData(
      "text/plain",
      event.currentTarget.dataset.productId,
    );
    //console.log('Drag started for product with ID:', event.currentTarget.dataset.productId," and date ",event.currentTarget.dataset.date);
  }

  handleDragOver(event) {
    event.preventDefault();
    //console.log('Drag over event');
  }

  async handleDrop(event) {
    event.preventDefault();

    const calendarItems = document.querySelectorAll(".calendar-item");

    calendarItems.forEach((element) => {
      element.setAttribute("draggable", "false");
      var date = element.dataset.date;
    });

    const productId = event.dataTransfer.getData("text/plain");
    const dragSource = document.querySelector(
      `.calendar-item[data-product-id="${productId}"]`,
    );
    const dragDate = dragSource ? dragSource.dataset.date : "unknown";
    const dropTarget = event.currentTarget;
    const dropDate = dropTarget.dataset.date;
    const dropProduct = dropTarget.dataset.productId;

    console.log("dragDate: ", dragDate);
    console.log("dropDate: ", dropDate);

    //console.log('Dragged product with ID:', productId, 'from date:', dragDate, ' Dropped on item: ', dropProduct, ' with date:', dropDate);

    var updateDeets = getJsonCookie("deets");

    let data_1 = {
      customerId: window.customerId,
      productId: productId,
      date: dropDate,
      products_per_month: updateDeets.products_per_month,
    };

    console.log("data_1: ", data_1);
    //const customerData_1 = await fetchAppProxyData("change_customer_product_date", data_1);

    let data_2 = {
      customerId: window.customerId,
      productId: dropProduct,
      date: dragDate,
      products_per_month: updateDeets.products_per_month,
    };
    console.log("data_2: ", data_2);

    const data = {
      customerId: window.customerId,
      dropProductId: productId,
      dropDate: dragDate,
      dragProductId: dropProduct,
      dragDate: dropDate,
    };
    const customerData_2 = await fetchAppProxyData(
      "change_customer_product_date",
      data,
    );

    const calendarDrawer = this.closest("calendar-drawer");
    if (calendarDrawer) {
      const event = new CustomEvent("on:calendar-drawer:before-open", {
        bubbles: true,
        cancelable: true,
      });
      calendarDrawer.dispatchEvent(event);
    }
  }
}

window.customElements.define("calendar-drawer", CalendarDrawer);